import State from '../interfaces/states/State';

import { createSelector } from 'reselect';
import getActivityYears from './getActivityYears';

const getFilteredActivityYears = createSelector(
  (state: State) => getActivityYears(state) ,
  (activityArray: number[]): number[] => {
    if (activityArray) {
      return activityArray.filter(function (item, pos) {
        // tslint:disable-next-line:triple-equals
        return activityArray.indexOf(item) == pos;
      });
    } else {
      return null;
    }
  }
);

export default getFilteredActivityYears;
